export function getRendererProps<T extends { slotProps?: T['slotProps'] }>(
  props: T,
  additionalSlotProps?: T['slotProps'],
): T {
  return {
    ...props,
    slotProps: {
      ...(props.slotProps || {}),
      ...additionalSlotProps,
    },
  };
}
